<template>
	<div class="group-condition">
		<div class="condition-type" v-if="localData.groupConditions.length > 1" style="text-align: center">
			<button v-show="localData.op === 'and'" class="btn-op" @click="localData.op = 'or'">و</button>
			<button v-show="localData.op === 'or'" class="btn-op" @click="localData.op = 'and'">یا</button>
		</div>
		<div class="conditions-container">
			<div v-for="(condition, index) in localData.groupConditions" :key="condition.id || index" class="section" :class="[condition.groupConditions ? 'group' : 'single']" style="position: relative">
				<a class="remove" href="#" @click="(e) => removeCondition(e, index)"><i class="fa fa-times"></i></a>
				<div v-if="condition.groupConditions" class="">
					<condition-group :fields="fields" :conditions="condition" :variables="variables" />
				</div>
				<div v-else>
					<condition-single v-model="localData.groupConditions[index]" :fields="fields" :condition="condition" :variables="variables" />
				</div>
			</div>
			<div class="add-condition-section">
				<a href="#" class="add-condition-btn" @click="addSingleCondition">افزودن شرط جدید</a>
				/
				<a href="#" class="add-condition-btn" @click="addGroupCondition">افزودن گروه جدید</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			modelValue: {
				type: Object,
			},
			fields: {
				type: Array,
			},
			conditions: {
				type: Object,
			},
			variables: {
				type: Array,
				default: () => [],
			},
		},
		emits: ['update:modelValue'],
		data() {
			return { localData: { groupConditions: [] } }
		},
		watch: {
			localData: {
				deep: true,
				handler() {
					this.$emit('update:modelValue', this.localData)
				},
			},
		},
		mounted() {
			this.localData = {
				...(this.conditions || { op: 'and', groupConditions: [] }),
			}
		},
		methods: {
			addGroupCondition(e) {
				e.preventDefault()
				this.localData.groupConditions.push({
					op: 'and',
					groupConditions: [],
					id: this.idGenerator(5),
				})
			},
			idGenerator(n) {
				return Math.random().toString(36).substr(2, n)
			},
			addSingleCondition(e) {
				e.preventDefault()
				this.localData.groupConditions.push({
					id: this.idGenerator(5),
					field: '',
					condition: '=',
					value: '',
					type: 'staticValue',
				})
			},
			removeCondition(e, index) {
				e.preventDefault()
				this.localData.groupConditions.splice(index, 1)
			},
		},
	}
</script>

<style></style>